import type { SVGProps } from "react";
import { NREPORT_MARK_PATH } from "@/lib/brand";

/** The solid roof and two evidence lines stay legible down to a 16px favicon. */
export const LogoIcon = ({ className = "h-8 w-8", ...props }: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" {...props}>
    <path d={NREPORT_MARK_PATH} />
  </svg>
);
